export default "__VITE_ASSET__a95b529b__"